import AuthorWrapper from '@/layouts/AuthorWrapper'

const LegalCredits = () => import('@/pages/LegalCredits')

export default {
	path     : '/legal-credits',
	component: AuthorWrapper,
	children : [
		{
			path     : '/',
			name     : 'Legal and Credits',
			component: LegalCredits
		}
	]
}
